export const ALERT_DURATION = 1000; // 1 sec

export const TEST_IDS = {
  TITLE: 'text-box-title',
  LOADER: 'text-box-loader',
  COPY_BUTTON: 'text-box-copy-button'
};
